import { render, staticRenderFns } from "./verAutoPurOrders.vue?vue&type=template&id=a8705e60&"
import script from "./verAutoPurOrders.vue?vue&type=script&lang=js&"
export * from "./verAutoPurOrders.vue?vue&type=script&lang=js&"
import style0 from "./verAutoPurOrders.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "verAutoPurOrders.vue"
export default component.exports